import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Menu from '../components/menu';
import Footer from '../components/footer';
import ImageCarouselModal from './components/imageCarouselModal';

export default function Main() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    
    // Stany dla podglądu zdjęć oferty (Carousel)
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [showCarousel, setShowCarousel] = useState(false);

    // Stany dla formularza kontaktowego
    const [formData, setFormData] = useState({
        subject: '',
        company: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        message: '',
        agreement: false
    });

    const [status, setStatus] = useState({ type: '', msg: '' });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://megamont.pl/api/mainpage');
                setData(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Błąd podczas pobierania danych strony głównej:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Helper: Pobieranie pierwszej miniatury dla ofert z obsługą spacji i znaków specjalnych
    const getOfferImage = (offer) => {
        if (!offer.images) return null;
        try {
            const images = JSON.parse(offer.images);
            if (!Array.isArray(images) || images.length === 0) return null;
            const firstImg = images[0];
            
            const baseUrl = firstImg.includes('/') 
                ? `https://megamont.pl/uploads/${firstImg}` 
                : `https://megamont.pl/uploads/oferta_${offer.id}/${firstImg}`;

            // encodeURI zamieni polskie znaki i spacje na format bezpieczny dla URL
            return encodeURI(baseUrl);
        } catch (e) {
            return null;
        }
    };

    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        const fieldMap = {
            'Temat': 'subject', 'Company': 'company', 'Name': 'name',
            'Sname': 'surname', 'email': 'email', 'Phone': 'phone', 
            'Text': 'message', 'gridCheck': 'agreement'
        };
        const fieldName = fieldMap[id];
        if (fieldName) {
            setFormData(prev => ({
                ...prev,
                [fieldName]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.agreement) return;
        try {
            setStatus({ type: 'info', msg: 'Wysyłanie...' });
            await axios.post('https://megamont.pl/api/contact', formData);
            setStatus({ type: 'success', msg: 'Wiadomość została wysłana!' });
            setFormData({
                subject: '', company: '', name: '', surname: '',
                email: '', phone: '', message: '', agreement: false
            });
        } catch (error) {
            setStatus({ type: 'error', msg: 'Błąd wysyłania wiadomości.' });
        }
    };

    if (loading) return null;

    return (
        <main className='MainPage'>
            <Menu active={1} />
            
            <div className="fadeIn">
                <span>Pracujemy dla najlepszych</span>
                <img src="https://megamont.pl//assets/sign.gif" alt="Sign" />
            </div>

            {/* Hero Section */}
            <section className="Welcome" style={{ 
                backgroundImage: data?.hero ? `url('${encodeURI(`https://megamont.pl/uploads/${data.hero}`)}')` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed', // Opcjonalnie: efekt parallax
                position: 'relative'
            }}>
                <div className="cover" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}> {/* Przyciemnienie, żeby napisy były czytelne */}
                    <div className="content text-center">
                        <h1 className="display-3 fw-bold text-white">MEGAMONT</h1>
                        <p className="lead text-white">Specjaliści w dziedzinie konstrukcji stalowych. Jakość i precyzja od projektu po montaż.</p>
                    </div>
                </div>
            </section>

            {/* O Nas Section */}
            <section className="Aboutus py-5">
                <div className="content">
                    <h1 className="section-title mb-5">O Nas</h1>
                    <div className="row align-items-center">
                        <div className="col-xl-6 abtext pe-xl-5">
                            <h2 className="gradient-text mb-4">Megamont</h2>
                            <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.8' }}>
                                {data?.description}
                            </p>
                        </div>
                        <div className="col-xl-6">
                            <div 
                                className="Officeimg shadow-lg rounded-2" 
                                style={{ 
                                    /* Dodano cudzysłowy wewnątrz url('') */
                                    backgroundImage: `url('${encodeURI(`https://megamont.pl/uploads/${data?.image}`)}')`, 
                                    backgroundSize: 'cover', 
                                    backgroundPosition: 'center',
                                    height: '80vh'
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Oferta Section */}
            <section className="Offert bg-dark py-5 text-white">
                <div className="content container">
                    <h1 className="text-center mb-4 text-white">Nasza Oferta</h1>
                    <p className='shortText text-center mb-5 text-white-50'>Realizujemy projekty od podstaw, dbając o każdy szczegół konstrukcji.</p>
                    
                    <div className="row g-4">
                        {data?.offers?.map((offer, idx) => {
                            const img = getOfferImage(offer);
                            return (
                                <div className="col-xl-4 col-md-6" key={offer.id || idx}>
                                    <div 
                                        className="offer-card-main shadow-sm" 
                                        onClick={() => { setSelectedOffer(offer); setShowCarousel(true); }}
                                    >
                                        {/* TUTAJ POPRAWKA: url('${img}') - cudzysłowy naprawiają problem nawiasów w nazwach plików */}
                                        <div className="card-bg" style={{ backgroundImage: img ? `url('${img}')` : 'none' }}></div>
                                        <div className="card-content text-center">
                                            {!img && <i className="fas fa-building mb-3 fa-2x"></i>}
                                            <h5 className="text-uppercase m-0 fw-bold">{offer.name}</h5>
                                            <span className="view-gallery-btn small mt-2">Zobacz zdjęcia</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        
                        <div className="col-12 text-center mt-5">
                            <button className="btn btn-primary btn-lg px-5" onClick={() => navigate('/offert')}>
                                Zobacz pełną ofertę
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Realizacje Section */}
            <section className="Realizations py-5">
                <div className="content container">
                    <h1 className="text-center mb-5">Najnowsze Realizacje</h1>
                    <div className="row g-4">
                        {data?.realizations?.filter(r => r !== null).map((real) => {
                            const images = typeof real.images === 'string' ? JSON.parse(real.images || "[]") : real.images;
                            const firstImg = images?.length > 0 ? encodeURI(`https://megamont.pl/uploads/realizacja_${real.id}/${images[0]}`) : "";
                            return (
                                <div className="col-xl-4 col-md-6" key={real.id}>
                                    <div className="card h-100 border-0 shadow-lg realization-card">
                                        <div className="img-container overflow-hidden">
                                            <img src={firstImg} className="card-img-top" alt={real.name} style={{height: '250px', objectFit: 'cover'}} />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title fw-bold">{real.name}</h5>
                                            <p className="card-text text-muted small">{real.description?.substring(0, 100)}...</p>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="text-secondary small">
                                                    <i className="fas fa-map-pin me-1 text-primary"></i>{real.location}
                                                </div>
                                                <button className="btn btn-outline-primary btn-sm" onClick={() => navigate(`/realization/${real.id}`)}>Szczegóły</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Referencje & Partnerzy */}
            <section className="References py-5">
                <div className="content container">
                    <h1 className="text-center mb-5">Zaufali Nam</h1>
                    <div className="row g-3 mb-5">
                        {data?.references?.filter(ref => ref !== null).map((ref) => (
                            <div className="col-xl-3 col-6" key={ref.id}>
                                <div className="ref-img-wrapper shadow-sm">
                                    <img className='img-fluid rounded' src={encodeURI(`https://megamont.pl/uploads/references/${ref.name}`)} alt="Referencja" />
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className="Partners pt-5 border-top">
                        <h2 className="text-center mb-5">Nasi Partnerzy</h2>
                        <div className="row justify-content-center align-items-center g-4">
                            {data?.partners?.filter(p => p !== null).map((partner) => (
                                <div className="col-xl-2 col-4" key={partner.id}>
                                    <img className="img-fluid partner-logo" src={encodeURI(`https://megamont.pl/uploads/partners/${partner.name}`)} alt="Partner" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="Contact">
                <div className="content">
                    <h1>Kontakt</h1>
                    <p className='shortText'>Skontaktuj się z nami, aby omówić swój projekt konstrukcji stalowej.</p>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="content">
                                    <h2>Dane Kontaktowe</h2>
                                    <div className="row">
                                        <div className="col-6">
                                            <h4><i className="fas fa-map-marker-alt"></i>Adres</h4>
                                            <p>Sadowiec Wrzosy 46c 98-355 Działoszyn</p>
                                        </div>
                                        <div className="col-6">
                                            <h4><i className="fas fa-phone-alt"></i>Telefon</h4>
                                            <p>+48 515 238 870</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <h4><i className="fas fa-envelope"></i>Email</h4>
                                            <p>megamont@op.pl</p>
                                        </div>
                                    </div>
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2503.737156382098!2d18.8687707!3d51.1258679!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDA3JzMzLjEiTiAxOMKwNTInMDcuNiJF!5e0!3m2!1spl!2spl!4v1620000000000!5m2!1spl!2spl" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>                

            {showCarousel && selectedOffer && (
                <ImageCarouselModal 
                    Offer={selectedOffer} 
                    onClose={() => { setShowCarousel(false); setSelectedOffer(null); }} 
                />
            )}

            <Footer />

            <style>{`
                .offer-card-main {
                    position: relative;
                    height: 220px;
                    border-radius: 15px;
                    overflow: hidden;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #222;
                    transition: all 0.3s ease;
                }
                .card-bg {
                    position: absolute;
                    top:0; left:0; width:100%; height:100%;
                    background-size: cover;
                    background-position: center;
                    opacity: 0.4;
                    transition: 0.5s ease;
                }
                .offer-card-main:hover .card-bg {
                    opacity: 0.7;
                    transform: scale(1.1);
                }
                .card-content {
                    position: relative;
                    z-index: 2;
                    padding: 20px;
                }
                .view-gallery-btn {
                    display: block;
                    background: rgba(255,255,255,0.2);
                    padding: 5px 15px;
                    border-radius: 20px;
                    opacity: 0;
                    transform: translateY(10px);
                    transition: 0.3s;
                }
                .offer-card-main:hover .view-gallery-btn {
                    opacity: 1;
                    transform: translateY(0);
                }
                .realization-card:hover img {
                    transform: scale(1.05);
                    transition: 0.5s;
                }
                .ref-img-wrapper img {
                    transition: 0.3s;
                    cursor: pointer;
                }
                .ref-img-wrapper img:hover {
                    transform: scale(1.02);
                }
            `}</style>
        </main>
    );
}